<mat-form-field class="w-full">
  <mat-label>Current Company</mat-label>
  <mat-select (opened)="searchInput.focus()" [formControl]="companyPicker" class="w-full">
    <mat-form-field class="w-full p-1">
      <input
        type="text"
        matInput
        [formControl]="companySearch"
        autocomplete="off"
        #searchInput
        (keydown)="$event.stopPropagation()"
      />
    </mat-form-field>
    <mat-option *ngFor="let company of companies$ | async; trackBy: 'id' | trackByKey" [value]="company.id"
      >{{ company.name }} ({{ company.id }})
      <span class="font-bold"
        >[<ng-container *ngIf="company.billingSubsidiary === 'lohi'">OA</ng-container>
        <ng-container *ngIf="company.billingSubsidiary === '5F'">OO</ng-container>
        <ng-container *ngIf="company.billingSubsidiary === 'none'">Classic</ng-container>]</span
      ></mat-option
    >
  </mat-select>
</mat-form-field>
